import React, { Component } from "react";

class ProductSearchContainer extends Component {
    render() {
        const { children, ...rest } = this.props;

        return (
            <div className="container-fluid" {...rest}>
                {children}
            </div>
        );
    }
}

export default ProductSearchContainer;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Container.js